import { LogisticAsyncTaskEntityType } from '../logistic-async-task.types';

export const LogisticRequestTimezoneTask = {
  entityType: LogisticAsyncTaskEntityType.Request,
  type: 'calculateTimezone',
  stages: {
    Calculate: 'calculate',
    DispatchWebhook: 'dispatchWebhook',
  },
} as const;

export type LogisticRequestCalculateTimezonePayload = {
  deliveryAddress: string | null;
};

export type LogisticRequestTimezoneTaskDefinition = {
  entityType: typeof LogisticRequestTimezoneTask.entityType;
  entityId: number;
  type: typeof LogisticRequestTimezoneTask.type;
  stage: typeof LogisticRequestTimezoneTask.stages.Calculate;
  payload: LogisticRequestCalculateTimezonePayload;
};
